import styled from 'styled-components';

import {border, colors, font} from 'theme';

export const Root = styled.div`
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    border: 1px solid ${colors.brandPrimary};
    border-radius: ${border.radius};
    padding: 12px 16px;
    background-color: #f2f7ff;
`;

export const IconSection = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 24px;
    height: 100%;
    padding-top: 2px;
`;

export const TextSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1px;
`;

export const Description = styled.div`
    font-family: ${font.family.primary};
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: ${colors.textGrey1};
`;

export const Title = styled.div`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: ${colors.textSecondary};
`;
